import { z } from 'zod';
import { BaseElementSchema } from '@/components/canvas/document/schema/elementBase';
import { TextContentDataSchema, TextStyleOverrideSchema } from '@/components/canvas/elements/text/schema';

export const VectorElementSchema = BaseElementSchema.extend({
  type: z.literal('vector'),
  data: z.object({
    shape: z.enum(['heart', 'polygon', 'star', 'path']),
    polygonSides: z.number().optional(),
    starPoints: z.number().optional(),
    starInnerRatio: z.number().optional(),
    pathData: z.string().optional(),
    text: TextContentDataSchema.optional(),
    textStyle: TextStyleOverrideSchema.partial().optional(),
  }),
});
